module.exports = __WEBPACK_EXTERNAL_MODULE_17__;


//////////////////
// WEBPACK FOOTER
// external "angular-messages"
// module id = 17
// module chunks = 0